import * as React from 'react';
import { Link as RouterLink } from "react-router-dom";
import { I18n, Translate } from 'react-redux-i18n';
import YoutubeEmbed from '../YoutubeEmbed';
import CommentBtnRight from './components/CommentBtnRight';
import {Share, Comment, TrendingDown, TrendingUp} from "theme/icon";
import { shareComment } from 'utils/shareComment';

// const ExpandMore = styled((props) => {
//     const { expand, ...other } = props;
//     return <IconButton {...other} />;
// })(({ theme, expand }) => ({
//     transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
//     marginLeft: 'auto',
//     transition: theme.transitions.create('transform', {
//         duration: theme.transitions.duration.shortest,
//     }),
// }));


function getEmbedId(url) {
    if (!url || typeof url !== 'string') {
        return false;
    }
    const array = url.split(' ');
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
    for (let index = 0; index < array.length; index++) {
        var element = array[index];
        if (element.indexOf("https://") >= 0) {
            var match = element.match(regExp);
            if (match && match[7].length == 11) {
                return match[7];
            } else {
                return false;
            }
        }
    }
}

const TICKER_SPLIT_RE = /(#[A-Za-z][A-Za-z.]{0,9})/g;
const TICKER_MATCH_RE = /^#[A-Za-z][A-Za-z.]{0,9}$/;

function renderCommentContent(comment) {
    if (!comment) {
        return null;
    }
    return comment.split(TICKER_SPLIT_RE).map((part, index) => {
        if (TICKER_MATCH_RE.test(part)) {
            const ticker = part.slice(1).toUpperCase();
            return (
                <RouterLink
                    key={index}
                    to={`/stock/${ticker}`}
                    className="comment-ticker"
                >
                    {part}
                </RouterLink>
            );
        }
        return <React.Fragment key={index}>{part}</React.Fragment>;
    });
}

export default function CommentItem(props) {
    const [expanded, setExpanded] = React.useState(false);
    const [previewOpen, setPreviewOpen] = React.useState(false);
    const item = props.item || {};
    const user = item.user || {};
    const like = item.like || { countUp: 0, countDown: 0, reaction: null };
    const username = user.username || 'Usuario';
    const avatarFallback = `https://ui-avatars.com/api/?name=${encodeURIComponent(username)}&background=random&rounded=true&size=64`;

    React.useEffect(() => {
        if (!previewOpen) {
            return undefined;
        }
        const onKeyDown = (event) => {
            if (event.key === 'Escape') {
                setPreviewOpen(false);
            }
        };
        document.addEventListener('keydown', onKeyDown);
        return () => document.removeEventListener('keydown', onKeyDown);
    }, [previewOpen]);

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    const handleShare = async (event) => {
        event.preventDefault();
        event.stopPropagation();
        await shareComment(item);
    };

    const openPreview = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setPreviewOpen(true);
    };

    const closePreview = () => {
        setPreviewOpen(false);
    };

    return (
        <>
        <div className='card' style={{ "marginTop": "10px", "marginBottom": "10px" }}>
            <div className='card-header'
            >
                <div style={{ "display": "flex", "alignItems": "center", "gap": "10px" }}>
                 <img
                    className='avatar-sm'
                    src={user.avatar || avatarFallback}
                    alt={username}
                />
                {user.id ? (
                    <RouterLink
                        className='card-header-title'
                        to={"/profile/" + user.id}
                    >
                        {username}
                    </RouterLink>
                ) : (
                    <span className='card-header-title'>{username}</span>
                )}
                </div>

                <div style={{ "display": "flex", "alignItems": "center", "gap": "10px" }}>
                    <span className='card-header-subtitle'>{item.created_at}</span>
                    <CommentBtnRight item={item} />
                </div>
            </div>
            {
                item.media && (
                    <button
                        type="button"
                        className="comment-media-btn"
                        onClick={openPreview}
                        aria-label={I18n.t('wall_image_expand')}
                    >
                        <img className='card-media'
                            height="auto"
                            width="100%"
                            src={item.media}
                            alt=""
                        />
                    </button>
                )
            }
            {
                getEmbedId(item.comment) && (<YoutubeEmbed embedId={getEmbedId(item.comment)} />)
            }

            <div className='card-content'>
                <div style={{ "whiteSpace": "pre-wrap" }}>
                    {renderCommentContent(item.comment)}
                </div>

            </div>
            <div className='card-actions' disableSpacing style={{ "display": "flex", "justifyContent": "space-between" }}>
                <div>
                    <span style={{ "color": "#9f9898", fontSize: "12px" }}>{like.countUp}</span>
                    <span aria-label="up" onClick={props.onClickUp} className='icon-button'>
                          <TrendingUp style={{ color: like.reaction === 1 && "#facc15" }} />
                    </span>

                    <span style={{ "color": "#9f9898", fontSize: "12px" }}>{like.countDown}</span>
                    <span aria-label="down" onClick={props.onClickDown} className='icon-button'>
                       <TrendingDown style={{ color: like.reaction === 2 && "#facc15" }} />
                    </span>
                </div>
                <div>
                    <span style={{ "color": "#9f9898",fontSize: "12px", padding: "3px" }}>{item.count_subcomment}</span>
                    <RouterLink to={item.id ? `/comment?id=${item.id}` : '/comment'}>
                        <span className='icon-button'  onClick={props.onClickComment}>
                            <Comment />
                        </span>
                    </RouterLink>
                    <span style={{ "color": "#9f9898",fontSize: "12px", padding: "3px" }}>{"0"}</span>
                    <button
                        type="button"
                        className='icon-button'
                        aria-label="Share"
                        onClick={handleShare}
                    >
                        <Share />
                    </button>
                </div>
            </div>
        </div>

        {previewOpen && item.media && (
            <div
                className="comment-image-lightbox"
                role="presentation"
                onClick={(event) => {
                    if (event.target === event.currentTarget) {
                        closePreview();
                    }
                }}
            >
                <div
                    className="comment-image-lightbox-inner"
                    role="dialog"
                    aria-modal="true"
                    aria-label={I18n.t('wall_image_expand')}
                >
                    <div className="comment-image-lightbox-actions">
                        <button
                            type="button"
                            className="btn btn-text btn-sm comment-image-lightbox-close"
                            onClick={closePreview}
                        >
                            <Translate value="close" />
                        </button>
                    </div>
                    <img
                        className="comment-image-lightbox-img"
                        src={item.media}
                        alt={I18n.t('wall_image_expand')}
                    />
                </div>
            </div>
        )}
        </>
    );
}
/**
 * color="disabled" 
 *  <ExpandMore
                    expand={expanded}
                    onClick={handleExpandClick}
                    aria-expanded={expanded}
                    aria-label="show more"
                >
                    <ExpandMoreIcon />
                </ExpandMore>
 <Collapse in={expanded} timeout="auto" unmountOnExit collapsedSize={"height:30px"}>
   <span style={{ "whiteSpace": "pre-wrap" }} >{props.item.comment}</span>
 </Collapse>
            <CardContent>
               
            </CardContent>
 */